"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var User_1 = require("../api/User");
var UrlParam_1 = require("../helpers/UrlParam");
var UserConnector = /** @class */ (function () {
    function UserConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Get user list related to corporate Firm
     * @param apiParams
     * @param contactType
     */
    UserConnector.prototype.getCorporateFirmUsers = function (apiParams, contactType) {
        var params = new URLSearchParams();
        if (contactType) {
            UrlParam_1.appendParam(params, 'contactType', contactType);
        }
        UrlParam_1.appendDefaultParams(params, apiParams);
        return fetchRequest_1.fetchRequestWithPagination(User_1.getCorporateFirmUsersUsingGET(params), this.baseUrl);
    };
    return UserConnector;
}());
exports.default = UserConnector;
